import { userInfoStore } from '../store/userInfoStore';

export const exchangeAmountByRate = ({
  rate,
  dataKey,
  spinInfo,
  currency,
  precision,
  currentUserId,
}) => {
  const amountPrecision = 10 ** +precision > 1 ? 10 ** +precision : 100;
  let model;
  // eslint-disable-next-line
  if (+currentUserId === +spinInfo?.userId || !spinInfo.userId || spinInfo?.currencyCode === currency) {
    // eslint-disable-next-line
    model = { amount: Math.trunc(Math.round((spinInfo?.amount || spinInfo?.amonut) * amountPrecision)) / amountPrecision, winAmount: Math.trunc(Math.round(spinInfo?.winAmount * amountPrecision)) / amountPrecision, };
  } else {
    // eslint-disable-next-line
      model = { amount: Math.trunc((spinInfo?.coinAmount / +rate) * amountPrecision) / amountPrecision, winAmount: Math.trunc((spinInfo?.winCoinAmount / +rate) * amountPrecision) / amountPrecision, };
  }
  return model[dataKey];
};

export const exchangeAmount = (amount) => {
  const { rate, precision } = userInfoStore;
  const amountPrecision = 10 ** +precision > 1 ? 10 ** +precision : 100;
  return Math.trunc((amount / +rate) * amountPrecision) / amountPrecision;
};
